import { render, staticRenderFns } from "./ShareOffer.vue?vue&type=template&id=4bb21e68&"
import script from "./ShareOffer.vue?vue&type=script&lang=ts&"
export * from "./ShareOffer.vue?vue&type=script&lang=ts&"
import style0 from "./ShareOffer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports